import { render } from "./SelectRolePermissionsDialog.vue?vue&type=template&id=40d25cac&scoped=true"
import script from "./SelectRolePermissionsDialog.vue?vue&type=script&lang=js"
export * from "./SelectRolePermissionsDialog.vue?vue&type=script&lang=js"

import "./SelectRolePermissionsDialog.vue?vue&type=style&index=0&id=40d25cac&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40d25cac"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QCardSection,QSpace,QBtn,QInput,QInnerLoading});qInstall(script, 'directives', {ClosePopup});
